import { cn } from "@/lib/utils";

type DealershipListingIconProps = {
  className?: string;
  size?: "xs" | "sm" | "md" | "lg";
};

/** comp-01 aspect ratio (~4:1); slightly taller than adjacent size-3 / 15px icons. */
const SIZE_CLASS = {
  xs: "h-3 w-[3rem]",
  sm: "h-3.5 w-[3.5rem]",
  md: "h-4 w-[4.05rem]",
  lg: "h-[17px] w-[4.35rem]",
} as const;

const DEALERSHIP_LISTING_ICON_SRC = "/dealership-listing-icon.png?v=2";

/** Uploaded comp-01 car graphic beside dealership names on listing cards. */
export function DealershipListingIcon({
  className,
  size = "md",
}: DealershipListingIconProps) {
  return (
    <img
      src={DEALERSHIP_LISTING_ICON_SRC}
      alt=""
      aria-hidden
      width={633}
      height={155}
      loading="lazy"
      decoding="async"
      className={cn(
        SIZE_CLASS[size],
        "shrink-0 object-contain object-center",
        className,
      )}
    />
  );
}
